import React from 'react'
import styled from 'styled-components';
import {InnerLayout} from '../styles/Layouts';
import Title from '../Components/Title';
import ProgressBar from './ProgressBar';

function Skills() {
    return (
        <SkillsStyled>
            
                <Title title={'My Skills'} span={'my skills'} />
                <InnerLayout>
                    <div className="skills">
                        <ProgressBar 
                            title={'HTML5'}
                            width={'85%'}
                            text={'85%'}
                        />
                        <ProgressBar 
                            title={'CSS3'}
                            width={'85%'}
                            text={'85%'}
                        />
                        <ProgressBar 
                            title={'JAVASCRIPT'}
                            width={'90%'}
                            text={'90%'}
                        />
                        <ProgressBar 
                            title={'EXPRESSJS'}
                            width={'90%'}
                            text={'90%'}
                        />
                        <ProgressBar 
                            title={'SEQUELIZE-ORM(NodeJS)'}
                            width={'90%'}
                            text={'90%'}
                        />
                        <ProgressBar 
                            title={'PYTHON'}
                            width={'60%'}
                            text={'60%'}
                        />
                        <ProgressBar 
                            title={'REACT JS'}
                            width={'75%'}
                            text={'75%'}
                        />
                        <ProgressBar 
                            title={'PANDAS'}
                            width={'75%'}
                            text={'75%'}
                        />
                        <ProgressBar 
                            title={'AWS-SERVERLESS'}
                            width={'70%'}
                            text={'70%'}
                        />
                        <ProgressBar 
                            title={'GIT'}
                            width={'80%'}
                            text={'80%'}
                        />
                        <ProgressBar 
                            title={'PHP-LARAVEL'}
                            width={'80%'}
                            text={'80%'}
                        />
                        <ProgressBar 
                            title={'NETLIFY'}
                            width={'85%'}
                            text={'85%'}
                        />
                        <ProgressBar 
                            title={'DJANGO'}
                            width={'60%'}
                            text={'60%'}
                        />
                    </div>
                </InnerLayout>
        </SkillsStyled>
    )
}

const SkillsStyled = styled.section`
    .skills{
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-row-gap: 2rem;
        grid-column-gap: 3rem;
        @media screen and (max-width: 700px){
            grid-template-columns: repeat(1, 1fr);
        }
    }
`;

export default Skills;
